export const InquiryStatusEnum = {
  Pending: 1,
  InProgress: 2,
  Closed: 3,
};

export const InquiryStatus = {
  [InquiryStatusEnum.Pending]: 'Pending',
  [InquiryStatusEnum.InProgress]: 'In Progress',
  [InquiryStatusEnum.Closed]: 'Closed',
};

export const InquiryStatusArray = [
  {
    id: InquiryStatusEnum.Pending,
    name: InquiryStatus[InquiryStatusEnum.Pending],
  },
  {
    id: InquiryStatusEnum.InProgress,
    name: InquiryStatus[InquiryStatusEnum.InProgress],
  },
  {
    id: InquiryStatusEnum.Closed,
    name: InquiryStatus[InquiryStatusEnum.Closed],
  },
];

export const bulkActions = {
  leadSourceUpdate: {
    id: 'leadSourceUpdate',
    name: 'Update Lead Source',
  },
  leadStatusUpdate: {
    id: 'leadStatusUpdate',
    name: 'Update Inquiry Status',
  },
  exportCSV: {
    id: 'exportCSV',
    name: 'Export CSV',
  },
};
